import { Table as AntdTable } from 'antd';
import { createGuardedComponent } from '../../provider/create-guarded-component';

export type { TableColumnsType, TableProps } from 'antd';

export const Table = createGuardedComponent(AntdTable) as typeof AntdTable;
